import { render, staticRenderFns } from "./CadastroHierarquia.vue?vue&type=template&id=6d72f37a&scoped=true&"
import script from "./CadastroHierarquia.vue?vue&type=script&lang=js&"
export * from "./CadastroHierarquia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d72f37a",
  null
  
)

export default component.exports